import * as actionTypes from 'constants/actionTypes';

import { initialState } from 'selectors/contacts';

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.CONTACTS_FETCH_SUCCESS:
      return [...payload.collection];
    case actionTypes.CONTACTS_RESET:
      return initialState;
    default:
      return state;
  }
};
